'use client';

import React from 'react';
import LegalDoc from '@/components/LegalDoc';
import { PRIVACY } from '@/lib/legal/documents';
import { useLanguage } from '@/contexts/LanguageContext';

export default function PrivacyPage() {
  const { language } = useLanguage();
  const isEs = language === 'es';

  return (
    <LegalDoc
      title={isEs ? 'Aviso de privacidad' : 'Privacy notice'}
      intro={
        isEs
          ? 'Qué datos guardamos, para qué los usamos y con quién los compartimos. Sin letras chiquitas.'
          : 'What data we hold, what we use it for and who we share it with. No fine print.'
      }
    >
      <div className="space-y-9">
        {PRIVACY.map((section) => (
          <section key={section.heading.en}>
            <h2 className="font-display text-[18px] font-semibold tracking-tight text-ink">
              {isEs ? section.heading.es : section.heading.en}
            </h2>
            <div className="mt-3 space-y-3">
              {section.body.map((p, i) => (
                <p key={i} className="text-[14.5px] leading-relaxed text-ink-soft">
                  {isEs ? p.es : p.en}
                </p>
              ))}
            </div>
          </section>
        ))}
      </div>
    </LegalDoc>
  );
}
